/**
 * Shares one in-flight promise per key.
 *
 * Several atoms legitimately derive different views of the same query -- the
 * incident runtime list is read both with and without a disabled-models filter,
 * and the stats aggregation is read by the stats tiles and by the time-series
 * chart -- and each read would otherwise issue its own identical request on the
 * same view load. Keyed on the request itself, the concurrent reads share one
 * response.
 *
 * The entry is dropped as soon as the promise settles, so this coalesces
 * concurrent requests rather than caching them: a read after the response has
 * landed fetches again, which keeps the 15-minute refresh cycle intact.
 */
const inFlight = new Map<string, Promise<unknown>>();

export function dedupeInFlight<T>(key: string, run: () => Promise<T>): Promise<T> {
  const existing = inFlight.get(key);
  if (existing != null) {
    return existing as Promise<T>;
  }

  const pending = run().finally(() => {
    inFlight.delete(key);
  });
  inFlight.set(key, pending);
  return pending;
}
